<div class="lottery-popup-wrapper">
  <img lib-amdocs-image-version class="lottery-popup-img" src="assets/icons/trophy.svg" />
  <div class="label-h4 lottery-popup-title">
    {{amdocsContentConstant?.lotteryPopup.title}}
  </div>
  <div class="text-small-normal lottery-popup-description">
    {{amdocsContentConstant?.lotteryPopup.text}}
  </div>
  <div class="lottery-popup-btn-wrapper">
    <button class="btn btn-medium primary send-notifications-btn"
            (click)="close()">
      {{amdocsContentConstant?.lotteryPopup.button}}
    </button>
  </div>
</div>
